import { createFileRoute } from '@tanstack/react-router';
import { AdminUsersPage } from '@/features/admin/admin-users-page';

export const Route = createFileRoute('/admin/users/')({
  component: AdminUsersIndexRoute,
});

function AdminUsersIndexRoute() {
  return <AdminUsersPage />;
}
